
<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h2>DART Deals</h2>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <list-controls [search]="dartDeals.searchText" [limit]="dartDeals.pageSize" [page]="dartDeals.currentPage" [numPages]="dartDeals.maxPages" [totalCount]="dartDeals.filteredLength" (onChange)="onListControlsChange($event)">
        <button class="btn btn-primary" importDartDeal type="button" (closed)="importDartDealDialogClosed($event)">Import DART Deal</button>
      </list-controls>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row" *ngFor="let dartDeal of dartDeals.filtered">
        <div class="col">
          <div class="card-item">
            <div class="d-inline-flex align-items-baseline md-3">
              <h4>{{ dartDeal.dealKey }}<span class="badge badge-secondary ml-2" *ngIf="dartDeal.quicksilver">QS</span></h4><a class="ml-2 align-bottom" *ngIf="dartDeal.projectId" href="/#/project?id={{ dartDeal.projectId}}" data-toggle="tooltip" title="{{ dartDeal.projectName}}">Related project</a>
            </div>
            <property-container>
              <property-item>&nbsp;</property-item>
            </property-container>
            <div class="row justify-content-center">
              <div class="col-10">
                <div class="row border-bottom">
                  <div class="col-2"></div>
                  <div class="col-2 pl-4">
                    <h6>Total</h6>
                  </div>
                  <div class="col-2 pl-4">
                    <h6>Planned</h6>
                  </div>
                  <div class="col-2 pl-4">
                    <h6>Available</h6>
                  </div>
                  <div class="col-2 pl-4">
                    <h6>Ordered</h6>
                  </div>
                  <div class="col-2 pl-4">
                    <h6>Type's Count</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-2">
                    <h6>Devices</h6>
                  </div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.asset.total }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.asset.planned }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.asset.available }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.asset.ordered }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.asset.solutionCount }}</span></div>
                </div>
                <div class="row">
                  <div class="col-2">
                    <h6>Accessories</h6>
                  </div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.accessory.total }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.accessory.planned }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.accessory.available }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.accessory.ordered }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.accessory.solutionCount }}</span></div>
                </div>
                <div class="row">
                  <div class="col-2">
                    <h6>Software Solutions</h6>
                  </div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.software.total }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.software.planned }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.software.available }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.software.ordered }}</span></div>
                  <div class="col-2 text-right pr-5"><span>{{ dartDeal.software.solutionCount }}</span></div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="float-right" *ngIf="!dartDeal.asset.planned &amp;&amp; !dartDeal.accessory.planned &amp;&amp; !dartDeal.software.planned">
              <button class="btn btn-outline-danger" (click)="remove(dartDeal.id)"><span class="oi oi-trash"></span> Remove</button>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>